module.exports = __webpack_public_path__ + "img/ubiqum.db4099fb.png";